<div class="p-grid" style="padding-top: 10px">
  <div class="p-col-7">
    {{ announcementMatchingList?.announcement.title }}({{
      announcementMatchingList?.announcement.announcementId
    }})
    <br />
    <button
      class="btn btn-primary"
      [routerLink]="['../../matching-announcements']"
    >
      <i class="fa fa-arrow-left"></i>
      {{ 'label.MatchingList' | translate }}
    </button>
    <a
      *ngIf="announcementMatchingList"
      [href]="announcementUrl"
      target="_blank"
    >
      {{ 'label.LinkOnLive' | translate }}
    </a>
  </div>
  <div class="p-col-5 matching-list-action-panel">
    <!-- <button (click)="onRegenerate()">{{ 'label.Regenerate' | translate}}</button> -->
    <hr-matching-generate-on-announcement
      [display]="displayModal"
      [regenerateAnnouncementId]="
        announcementMatchingList?.announcement?.announcementId
      "
      [isRegenerate]="true"
      (onAdd)="onReGenerate($event)"
      (onClose)="onClose($event)"
      (onUpdate)="onUpdateTable($event)"
    >
    </hr-matching-generate-on-announcement>
    <button (click)="onApproveMatchingList()">
      {{ 'label.ApproveSend' | translate }}
    </button>
    <button
      [disabled]="
        !hasViewMatchingListPermission ||
        !hasApproveMatchingListPermission ||
        !hasExpressApprovePermission
      "
      class="btn btn-primary"
      (click)="onApprove(announcementMatchingList?.announcementMatchingListId)"
    >
      {{ 'label.ExpressApprove' | translate }}
    </button>
  </div>
</div>
<div class="p-grid">
  <div class="p-col-3">
    <p-table
      [value]="announcementMatchingList?.matchingJobseekers"
      selectionMode="single"
      showGridlines
      [(selection)]="selectedMatchingJobseeker"
      (onRowSelect)="onSelectJobseeker($event)"
      (onRowUnselect)="onUnselectJobseeker()"
      #dt
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 1.6em">#</th>
          <th style="width: 9.1em">{{ 'label.Jobseeker' | translate }}</th>
          <th style="width: 4em">{{ 'label.Score' | translate }}</th>
          <th style="width: 8.5em">
            {{ 'label.Status' | translate }}
            <p-dropdown
              [options]="statuses"
              [style]="{ width: '100%' }"
              (onChange)="dt.filter($event.value, 'status', 'equals')"
            ></p-dropdown>
          </th>
          <th style="width: 8.4em">{{ 'label.Action' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-matchingJobseeker let-i="rowIndex">
        <tr
          [pSelectableRow]="matchingJobseeker"
          [ngClass]="{
            'inactive-jobseeker':
              $any(matchingJobseeker.jobseeker.status) != JobseekerStatus.Active
          }"
        >
          <td>{{ i + 1 }}</td>
          <td
            [ngClass]="{
              'row-highlight':
                matchingJobseeker?.isHighlight &&
                !matchingJobseeker.isMatchingProductBought,
              'row-highlight-green':
                matchingJobseeker?.isHighlight &&
                matchingJobseeker.isMatchingProductBought
            }"
          >
            <span style="text-decoration: underline">{{
              matchingJobseeker.fullName
            }}</span>
          </td>
          <td>{{ matchingJobseeker.finalScore * 100 | number : '1.0-2' }}%</td>
          <td>
            <span
              *ngIf="matchingJobseeker.status == MatchingJobseekerStatus.None"
              >&nbsp;
            </span>
            <span
              *ngIf="matchingJobseeker.status == MatchingJobseekerStatus.Accept"
              >{{ 'label.Accepted' | translate }}</span
            >
            <span
              *ngIf="matchingJobseeker.status == MatchingJobseekerStatus.Reject"
              >{{ 'label.Rejected' | translate }}</span
            >
            <span
              *ngIf="
                matchingJobseeker.status == MatchingJobseekerStatus.Ambiguous
              "
              >{{ 'label.Ambiguous' | translate }}</span
            >
          </td>
          <td>
            <button
              class="btn btn-default"
              (click)="onAcceptJobseeker(matchingJobseeker)"
              [disabled]="
                matchingJobseeker.status == MatchingJobseekerStatus.Accept
              "
            >
              <i
                class="fa fa-check"
                title="{{ 'label.approve' | translate }}"
              ></i>
            </button>
            &nbsp;
            <button
              class="btn btn-default"
              (click)="onRejectJobseeker(matchingJobseeker)"
              [disabled]="
                matchingJobseeker.status == MatchingJobseekerStatus.Reject
              "
            >
              <i
                class="fa fa-times"
                title="{{ 'label.reject' | translate }}"
              ></i>
            </button>
            &nbsp;
            <button
              class="btn btn-default"
              (click)="onSetJobseekerAmbiguous(matchingJobseeker)"
              [disabled]="
                matchingJobseeker.status == MatchingJobseekerStatus.Ambiguous
              "
            >
              <i
                class="fa fa-question"
                title="{{ 'label.ambiguous' | translate }}"
              ></i>
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div
    class="p-col-9"
    *ngIf="
      selectedMatchingJobseeker &&
      $any(selectedMatchingJobseeker.jobseeker.status) == JobseekerStatus.Active
    "
  >
    <p-table [value]="[selectedMatchingJobseeker]" showGridlines>
      <ng-template pTemplate="header">
        <tr>
          <th colspan="1" rowspan="2">{{ 'label.Position' | translate }}</th>
          <th colspan="2">{{ 'label.Categories' | translate }}</th>
          <th
            colspan="2"
            *ngIf="
              announcementMatchingList.announcement.workExperienceFrom !=
                null ||
              announcementMatchingList.announcement.workExperienceTo != null
            "
          >
            {{ 'label.Experience' | translate }}
          </th>

          <th
            rowspan="1"
            [attr.colspan]="mandatoryLanguagesOn && optionalLanguagesOn ? 2 : 1"
            *ngIf="
              announcementMatchingList.announcement.requiredLanguages.length > 0
            "
          >
            {{ 'label.Languages' | translate }}
          </th>
          <th rowspan="2">{{ 'label.Location' | translate }}</th>
          <th
            rowspan="2"
            *ngIf="
              announcementMatchingList.announcement.drivingLicenses.length > 0
            "
          >
            {{ 'label.DrivingLicense' | translate }}
          </th>
          <th rowspan="2">{{ 'label.FinalScore' | translate }}</th>
        </tr>
        <tr>
          <!-- <th>{{'label.CurrentPosition' | translate }}</th> -->
          <!-- <th>{{'label.RecentPosition' | translate }}</th> -->

          <!-- <th>{{'label.CurrentCategories' | translate }}</th> -->
          <th>{{ 'label.RecentCategories' | translate }}</th>
          <!-- <th>{{'label.CurrentAggCat' | translate }}</th> -->
          <th>{{ 'label.RecentAggCat' | translate }}</th>

          <th
            *ngIf="
              announcementMatchingList.announcement.workExperienceFrom !=
                null ||
              announcementMatchingList.announcement.workExperienceTo != null
            "
          >
            {{ 'label.ExperienceHead' | translate }}
          </th>
          <th
            *ngIf="
              announcementMatchingList.announcement.workExperienceFrom !=
                null ||
              announcementMatchingList.announcement.workExperienceTo != null
            "
          >
            {{ 'label.ExperienceSub' | translate }}
          </th>
          <th *ngIf="mandatoryLanguagesOn">
            {{ 'label.Mandatory' | translate }}
          </th>
          <th *ngIf="optionalLanguagesOn">
            {{ 'label.Optional' | translate }}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-matchingJobseeker let-i="rowIndex">
        <tr [pSelectableRow]="matchingJobseeker">
          <!-- <td>{{matchingJobseeker.currentPositionFinalScore*100 | number:'1.0-2' }}%</td> -->
          <td>
            {{
              matchingJobseeker.bestPositionFinalScore * 100 | number : '1.0-2'
            }}%
          </td>

          <!-- <td>{{matchingJobseeker.currentCategoryFinalScore*100 | number:'1.0-2'}}%</td> -->
          <td>
            {{
              matchingJobseeker.bestCategoryFinalScore * 100 | number : '1.0-2'
            }}%
          </td>
          <!-- <td>{{matchingJobseeker.currentAggregatedCategoryFinalScore*100 | number:'1.0-2' }}%</td> -->
          <td>
            {{
              matchingJobseeker.bestAggregatedCategoryFinalScore * 100
                | number : '1.0-2'
            }}%
          </td>

          <td
            *ngIf="
              announcementMatchingList.announcement.workExperienceFrom !=
                null ||
              announcementMatchingList.announcement.workExperienceTo != null
            "
          >
            {{
              matchingJobseeker.experienceSubCategoryScore * 100
                | number : '1.0-2'
            }}%
          </td>
          <td
            *ngIf="
              announcementMatchingList.announcement.workExperienceFrom !=
                null ||
              announcementMatchingList.announcement.workExperienceTo != null
            "
          >
            {{
              matchingJobseeker.experienceHeadCategoryScore * 100
                | number : '1.0-2'
            }}%
          </td>

          <td *ngIf="mandatoryLanguagesOn">
            {{
              matchingJobseeker.mandatoryLanguageScore * 100 | number : '1.0-2'
            }}%
          </td>
          <td *ngIf="optionalLanguagesOn">
            {{
              matchingJobseeker.optionalLanguageScore * 100 | number : '1.0-2'
            }}%
          </td>

          <td>
            {{ matchingJobseeker.locationFinalScore * 100 | number : '1.0-2' }}%
          </td>
          <td
            *ngIf="
              announcementMatchingList.announcement.drivingLicenses.length > 0
            "
          >
            {{
              matchingJobseeker.drivingLicenseFinalScore * 100
                | number : '1.0-2'
            }}%
          </td>

          <td>{{ matchingJobseeker.finalScore * 100 | number : '1.0-2' }}%</td>
        </tr>
      </ng-template>
    </p-table>
    <br />

    <div
      *ngIf="
        jobseekerMatchedAnnouncements &&
        jobseekerMatchedAnnouncements.length > 0
      "
    >
      <strong>{{ 'label.JobseekerAppliedToAnnouncements' | translate }}</strong>

      <div *ngFor="let announcement of jobseekerMatchedAnnouncements">
        <a
          [routerLink]="['../', announcement?.announcementMatchingListId]"
          target="_blank"
          >{{ announcement?.announcementTitle | translate }} -
          {{ announcement?.lastStatusUpdateDate | date : 'dd/MM/yyyy' }}</a
        >
      </div>
    </div>

    <router-outlet></router-outlet>
  </div>
</div>
